import React, { useState } from 'react';
import {
    FaBars,
    FaTimes,
    FaCalendarAlt,
} from "react-icons/fa";
import { NavLink } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { TbLogout } from "react-icons/tb";
import { signOut } from "firebase/auth";
import { auth } from '../firbase.config';
import { useDispatch } from 'react-redux';
import { loginUserData, savePhone } from '../redux/loginSlice';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [mobileOpen, setMobileOpen] = useState(false);

    const toggleMobile = () => setMobileOpen(!mobileOpen);

    const changeLanguageHandler = (lang) => {
        i18n.changeLanguage(lang);
    };

    const scrollToSection = (sectionId) => {
        setMobileOpen(false);
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        } else {
            navigate('/');
            setTimeout(() => {
                const el = document.getElementById(sectionId);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 300);
        }
    };

    const Logout = () => {
        signOut(auth).then(() => {
            localStorage.setItem('userToken', null)
            localStorage.setItem('userPhone', null)
            dispatch(loginUserData(null))
            dispatch(savePhone(null))
            alert("User logged out successfully")
            navigate('/login', { replace: true });
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <>
            <nav className="navbar-container" id="home">
                <div className="navbar-brand">
                    <img src={"/logo.png"} alt="Gowri Prasanna Convention Hall" />
                    <span className="navbar-brand-text">Gowri Prasanna Convention Hall</span>
                </div>

                <button className="nav-toggle" onClick={toggleMobile} aria-label="Toggle navigation">
                    {mobileOpen ? <FaTimes /> : <FaBars />}
                </button>

                <div className={`navbar-links ${mobileOpen ? 'mobile-open' : ''}`}>
                    <NavLink to="/" onClick={() => setMobileOpen(false)}>
                        {t('Home')}
                    </NavLink>
                    <span className="nav-link-item" onClick={() => scrollToSection('about')}>
                        About
                    </span>
                    <NavLink to="/Service" onClick={() => setMobileOpen(false)}>
                        {t('Services')}
                    </NavLink>
                    <a
                        href="https://www.google.com/maps/place/Gowri+Prasanna+convention+hall+G.M.B+complex/@13.3419388,77.1199452,3a,75y,90t/data=!3m8!1e2!3m6!1sAF1QipODRvSpK2srmz1s8ys8VluK1PXaT8PAeQ4_hufG!2e10!3e12!6shttps:%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipODRvSpK2srmz1s8ys8VluK1PXaT8PAeQ4_hufG%3Dw114-h86-k-no!7i1008!8i756!4m7!3m6!1s0x3bb02d82112bf5df:0x7feeb0fe65039e10!8m2!3d13.3419397!4d77.1199284!10e5!16s%2Fg%2F11qplvkhg8?entry=ttu"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setMobileOpen(false)}
                    >
                        {t('Gallery')}
                    </a>
                    <span className="nav-link-item" onClick={() => scrollToSection('contact')}>
                        Contact
                    </span>

                    <div className="nav-lang-group">
                        <button
                            className={`nav-lang-btn ${i18n.language === 'ka' ? 'active-lang' : ''}`}
                            onClick={() => changeLanguageHandler('ka')}
                        >
                            ಕನ್ನಡ
                        </button>
                        <button
                            className={`nav-lang-btn ${i18n.language === 'en' || !i18n.language ? 'active-lang' : ''}`}
                            onClick={() => changeLanguageHandler('en')}
                        >
                            EN
                        </button>
                    </div>

                    {/* <span
                        className="nav-book-btn"
                        onClick={() => scrollToSection('availability')}
                    >
                        <FaCalendarAlt /> {t('Book_now')}
                    </span> */}
                </div>
            </nav>
            <main>{children}</main>
        </>
    );
};

export default Sidebar;